import React from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  arrayOf,
  shape,
  string,
  bool,
  oneOfType,
  number,
  object,
} from 'prop-types'

import { EMPTY_ARRAY, EMPTY_OBJECT } from 'Utils/stableDefaults'

import CollapsedFormat from './Components/CollapsedFormat/CollapsedFormat'
import ExpandedFormat from './Components/ExpandedFormat/ExpandedFormat'
import { getQuantity } from './Utils/getQuantity'

function FormatsSection({
  data = EMPTY_ARRAY,
  title,
  showExpanded = false,
  showTooltip = false,
  summaryFileExtensions = EMPTY_OBJECT,
}) {
  return (
    <div className="details-area__section">
      <span className="details-area__section-subtitle">{title}</span>
      <div className={classnames('details-area__formats', showExpanded && 'details-area__formats--expanded')}>
        {data.map(
          ({
            title: formatTitle,
            fullName,
            extensionPath,
            fileSize,
            fileCount,
            version,
            rendererName,
            rendererVersion,
            itemFileVersions,
            item_file_versions: itemFileVersionsSnake,
          },
          index,
        ) => {
          const resolvedItemFileVersions = itemFileVersions ?? itemFileVersionsSnake ?? []

          return (
            showExpanded
              ? (
                <ExpandedFormat
                  key={`expanded-format-${index}`}
                  title={formatTitle}
                  extensionPath={extensionPath}
                  fileCount={fileCount}
                  fileSize={fileSize}
                  version={version}
                  rendererName={rendererName}
                  rendererVersion={rendererVersion}
                  itemFileVersions={resolvedItemFileVersions}
                  quantity={getQuantity(summaryFileExtensions, formatTitle)}
                  index={index}
                />
              )
              : (
                <CollapsedFormat
                  key={`format-${index}`}
                  title={formatTitle}
                  fullName={fullName}
                  fileCount={fileCount}
                  extensionPath={extensionPath}
                  fileSize={fileSize}
                  version={version}
                  rendererName={rendererName}
                  rendererVersion={rendererVersion}
                  itemFileVersions={resolvedItemFileVersions}
                  quantity={getQuantity(summaryFileExtensions, formatTitle)}
                  index={index}
                  showTooltip={showTooltip}
                />
              )
          )
        })}
      </div>
    </div>
  )
}

FormatsSection.propTypes = {
  data: arrayOf(shape({
    title: string.isRequired,
    fullName: string,
    extensionPath: string,
    fileSize: string.isRequired,
    version: string,
    rendererName: string,
    rendererVersion: oneOfType([string, number]),
    itemFileVersions: arrayOf(shape({
      version: oneOfType([string, number]),
      rendererName: string,
      rendererVersion: oneOfType([string, number]),
    })),
  })),
  title: string.isRequired,
  showExpanded: bool,
  showTooltip: bool,
  summaryFileExtensions: object,
}

export default FormatsSection
